export var UserTypologyId;
(function (UserTypologyId) {
  UserTypologyId[UserTypologyId["CUSTOMER"] = 2] = "CUSTOMER";
  UserTypologyId[UserTypologyId["TECHNICIAN"] = 3] = "TECHNICIAN";
  UserTypologyId[UserTypologyId["BACK_OFFICE_OPERATOR"] = 4] = "BACK_OFFICE_OPERATOR";
  UserTypologyId[UserTypologyId["SUPPLIER"] = 5] = "SUPPLIER";
  UserTypologyId[UserTypologyId["BACK_OFFICE_ADMINISTRATOR"] = 6] = "BACK_OFFICE_ADMINISTRATOR";
  UserTypologyId[UserTypologyId["WIKICASA_SERVICE_USER"] = 7] = "WIKICASA_SERVICE_USER";
  UserTypologyId[UserTypologyId["AUCTION_CONSULTANT"] = 8] = "AUCTION_CONSULTANT";
  UserTypologyId[UserTypologyId["AUCTION_GUARDINA"] = 9] = "AUCTION_GUARDINA";
  UserTypologyId[UserTypologyId["AUCTION_SUPERVISOR"] = 10] = "AUCTION_SUPERVISOR";
})(UserTypologyId || (UserTypologyId = {}));